function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{opacity:0.8;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(7.213)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M623.467,264.5H612.32a.821.821,0,0,1-.82-.82v-6.23a.492.492,0,0,1,.984,0v6.066H623.3V245.484h-10.82v6.066a.492.492,0,0,1-.984,0V245.32a.821.821,0,0,1,.82-.82h11.148a.821.821,0,0,1,.82.82V263.68A.821.821,0,0,1,623.467,264.5Z",
  transform: "translate(-611.5 -244.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 5.574)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 3.934)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M603.762,274.484H589.992a.492.492,0,1,1,0-.984h13.771a.492.492,0,0,1,0,.984Z",
  transform: "translate(-589.5 -273.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M593.926,270.353a.49.49,0,0,1-.348-.144l-3.934-3.934a.492.492,0,0,1,0-.7l3.934-3.934a.492.492,0,0,1,.7.7l-3.587,3.587,3.587,3.587a.492.492,0,0,1-.348.84Z",
  transform: "translate(-589.5 -261.5)"
}))));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgLogout, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Logout.fa290c03.svg";
export { ForwardRef as ReactComponent };